import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import useImportDocumentStore from './importDocumentStore';

export { useImportDocumentStore };

export const useServicerStore = create((set) => ({
  servicerId: [],
  userRole: null, // superAdmin, lender, borrower
  userId: null,
  isAdminHostname: false,

  setServicerId: (servicerId) => set({ servicerId }),
  setIsAdminHostname: (isAdminHostname) => set({ isAdminHostname }),
  setUserRole: (userRole) => set({ userRole }),
  setUserId: (userId) => set({ userId }),
}));

export const useFormStore = create((set) => ({
  tinTypeOptions: {},
  tinInputMask: {},

  setTinTypeOptions: (options, id) => {
    return set((state) => ({
      tinTypeOptions: { ...state.tinTypeOptions, [id]: options },
    }));
  },
  setTinInputMask: (mask, id) => {
    return set((state) => ({
      tinInputMask: { ...state.tinInputMask, [id]: mask },
    }));
  },
  removeTinTypeOptions: (id) => {
    return set((state) => {
      const newOptions = { ...state.tinTypeOptions };
      delete newOptions[id];
      return { tinTypeOptions: newOptions };
    });
  },
  removeTinInputMask: (id) => {
    return set((state) => {
      const newMask = { ...state.tinInputMask };
      delete newMask[id];
      return { tinInputMask: newMask };
    });
  },
}));

// Storing async mutations from formik submit handlers
// so we can wait for multiple promises to resolve in the parent component
// before refetching data and taking other actions
export const useMutationStore = create((set) => ({
  billMutations: [],

  addBillMutation: (mutation) => {
    return set((state) => ({
      billMutations: [...state.billMutations, mutation],
    }));
  },
  clearBillMutations: () => set({ billMutations: [] }),
}));

// UI related state
export const useUiStore = create((set) => ({
  sidebarWidth: 0,
  isFetching: false,
  onLoginRedirectUrl: null,
  loanHeaderHeight: 0,
  isMainOverflowHidden: false,

  setSidebarWidth: (width) => set({ sidebarWidth: width }),
  setIsFetching: (isFetching) => set({ isFetching }),
  setOnLoginRedirectUrl: (url) => set({ onLoginRedirectUrl: url }),
  setLoanHeaderHeight: (height) => set({ loanHeaderHeight: height }),
  setIsMainOverflowHidden: (isHidden) =>
    set({ isMainOverflowHidden: isHidden }),
}));

export const useInvoiceTableStore = create((set) => ({
  invoiceAmountsToApplyTotals: {},

  setInvoiceAmountsToApplyTotals: (totals) =>
    set({ invoiceAmountsToApplyTotals: totals }),

  updateInvoiceAmountById: (id, amount) =>
    set((state) => ({
      invoiceAmountsToApplyTotals: {
        ...state.invoiceAmountsToApplyTotals,
        [id]: amount,
      },
    })),
}));

// This is used for drag and drop of the array form fields
export const useFormContainerStore = create((set) => ({
  changeListItemOrderHandler: () => {},

  setChangeListItemOrderHandler: (handler) =>
    set({ changeListItemOrderHandler: handler }),
}));

// Impounds
export const useImpoundsStore = create((set) => ({
  invoices: [],
  bills: [],

  setInvoices: (invoices) => set({ invoices }),
  setBills: (bills) => set({ bills }),
}));

// Auth
export const useAuthStore = create(
  persist(
    (set) => ({
      authData: null,

      setAuthData: (authData) => set({ authData }),
    }),
    {
      name: 'auth-storage', // key in localStorage
      getStorage: () => localStorage,
      partialize: (state) => ({
        // only persist authData
        authData: state.authData,
      }),
    }
  )
);
